/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { Space, Button, Card, Popconfirm, Layout, Table, Input } from "antd";
import { ALL_NEWSLETTER, DELETE_NEWSLETTER } from "../../constants/api";
import { isSuperAdmin } from "../../constants/constent";

function NewsLetterTable() {
  const { Content } = Layout;
  const [state, setState] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        const fetchedData = data["data"].map((row, index) => ({
          key: index,
          ID: index + 1,
          Email: row.email,
          Action: (
            <Space>
              <Popconfirm
                title="Delete the task"
                description="Are you sure to delete this task?"
                onConfirm={() => deleteData(row.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button danger>Delete</Button>
              </Popconfirm>
            </Space>
          ),
        }));
        setState(fetchedData);
        setFilteredData(fetchedData);
      } else {
        setState([]);
        setFilteredData([]);
        setLoading(false);
      }
    };

    const errorFn = function () {
      setState([]);
      setFilteredData([]);
      setLoading(false);
    };

    getAPI(ALL_NEWSLETTER, successFn, errorFn, {});
  };

  const deleteData = (values) => {
    setLoading(true);
    let data = {
      id: values,
    };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getList();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_NEWSLETTER, data, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);

    const filtered = state.filter((data) =>
      data.Email.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "ID",
    },
    {
      title: "Email",
      dataIndex: "Email",
    },
    isSuperAdmin()
      ? {
          title: "Action",
          dataIndex: "Action",
        }
      : null,
  ].filter(Boolean);

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Newsletter Subcription"
            extra={
              <Space>
                <Input
                  placeholder="Search by email"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 240 }}
            />
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}

export default NewsLetterTable;
